import React, {useState, useContext, useEffect} from 'react';
import InputGroup from 'react-bootstrap/InputGroup';

import { FormContext } from 'context/FormContext';

import IconPlus from 'assets/images/icon_control_plus.svg';
import IconMinus from 'assets/images/icon_control_minus.svg';

const Counter = (props) => {
    const [value, setValue] = useState(props.defaultValue);
    const { formValues, setFormValues } = useContext(FormContext);

    const counterChange = (e) => {
        if(parseInt(e.target.value) <= props.max && parseInt(e.target.value) >= props.min){
            setFormValues({ ...formValues, [e.target.name]: parseInt(e.target.value) });
        }
    }

    const addToCounter = () => {
        if(formValues[props.name] < props.max){
            setFormValues({ ...formValues, [props.name]: parseInt(value) + 1 });
        }
    }

    const subtractFromCounter = () => {
        const val = formValues[props.name];

        if(val > props.min){
            setFormValues({ ...formValues, [props.name]: parseInt(val) - 1 });
        }
    }

    useEffect(() => {
        setValue(formValues[props.name]);
    }, [formValues, props.name]);

    return (
        <InputGroup className="mb-3 Counter">
            <input className="form-control" type="number" name={props.name} value={value} onChange={counterChange} min={props.min} max={props.max} />
            <InputGroup.Text>{props.label}</InputGroup.Text>
            <div className="d-flex justify-content-between counterControl">
                <img draggable="false" src={IconPlus} alt="plus" onClick={addToCounter} />
                <img draggable="false" src={IconMinus} alt="minus" onClick={subtractFromCounter} />
            </div>
        </InputGroup>
    );
}

export default Counter;